import { Spinner } from "react-bootstrap";

export default function LoadingSubscription() {
    return <div className="container my-auto py-4">
        <div className="row">
            <div className="col-11 col-lg-10 mx-auto">
                <div className="d-flex align-items-center justify-content-center">
                    <Spinner animation="border" ></Spinner>
                </div>
                <p className="text-center mg-t-10 tx-18">Criando sua assinatura...</p>

            </div>
        </div>
    </div>
}